module.exports = __webpack_public_path__ + "img/python.27a9405a.svg";